// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3q_xf","select":"Header_select__1_yOt","clinic":"Header_clinic__JVFDS"};